import React from 'react';
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    backgroundColor: 'rgb(255, 255, 255)',
    borderTopColor: 'rgba(0, 180, 216, 0.2)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-155">
      <div className="mx-auto max-w-4xl text-center" data-id="element-156">
        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-cyan-brand" data-id="element-157">
          👶 CONSTRUYE PROGRESO™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-158">
          El sistema N°1 para profesionales de Estimulación Temprana en
          Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-159">
          "Porque acompañar el neurodesarrollo con criterio no debería
          demandarte todas tus noches y fines de semana."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-160">
          <a href="mailto:construyeprogresoo@gmail.com" className="no-underline text-gray-600 hover:text-cyan-brand transition-colors" data-id="element-161">
            📧 construyeprogresoo@gmail.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-162">|</span>
          <span className="text-gray-600" data-id="element-163">📲 @construyeprogresoo</span>
          <span className="hidden sm:block text-gray-200" data-id="element-164">|</span>
          <a href="https://www.construyeprogreso.com" target="_blank" rel="noopener noreferrer" className="no-underline text-gray-600 hover:text-cyan-brand transition-colors" data-id="element-165">
            🌐 www.construyeprogreso.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24 bg-cyan-brand/30" data-id="element-166" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-167">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-168">
            © {new Date().getFullYear()} Construye Progreso™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-169">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
          <p className="text-[9px] text-gray-400 m-0 mt-4 leading-relaxed max-w-xl mx-auto" data-id="element-170">
            Este sitio no es parte de la plataforma de Meta ni de Meta
            Platforms, Inc. Además, este sitio NO está respaldado por Meta de
            ninguna manera. FACEBOOK es una marca registrada de META, Inc.
          </p>
        </div>
      </div>
    </footer>;
}